<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { ServicesBlock } from '../../types'

defineProps<{ block: ServicesBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-background) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container">
      <div class="site:max-w-3xl">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mt-5 site:max-w-2xl site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
      </div>

      <div class="site:mt-10 site:grid site:gap-5" :class="block.settings.columns === 2 ? 'site:@min-[48rem]:grid-cols-2' : 'site:@min-[48rem]:grid-cols-2 site:@min-[64rem]:grid-cols-3'">
        <article
          v-for="(item, index) in block.content.items"
          :key="item.id"
          class="site:flex site:min-h-64 site:flex-col site:border site:border-(--site-color-border) site:bg-(--site-color-surface) site:p-6 site:shadow-(--site-shadow-sm) site:@min-[40rem]:p-8"
          :style="{ borderRadius: 'var(--site-radius-md)' }"
        >
          <span class="site:mb-10 site:flex site:size-10 site:items-center site:justify-center site:rounded-full site:bg-(--site-color-accent) site:text-sm site:font-bold site:text-(--site-color-primary)">
            {{ String(index + 1).padStart(2, '0') }}
          </span>
          <SiteEditableText v-model="item.title" as="h3" class="site-heading site:text-xl site:font-bold" />
          <SiteEditableText v-model="item.description" as="p" class="site:mt-3 site:flex-1 site:leading-7 site:text-(--site-color-muted-text)" />
          <SiteLink v-if="item.action" :link="item.action" class="site:mt-6 site:text-sm site:font-semibold site:text-(--site-color-primary)">
            {{ item.action.label }}
          </SiteLink>
        </article>
      </div>

      <SiteLink v-if="block.content.action" :link="block.content.action" class="site-site-button site:mt-8">
        {{ block.content.action.label }}
      </SiteLink>
    </div>
  </section>
</template>
